import React from 'react';

import { Breadcrumb as AntBreadcrumb } from 'antd';
import { BreadcrumbItemProps } from 'antd/lib/breadcrumb';

export interface IBreadcrumbItemProps extends BreadcrumbItemProps {}

interface BreadcrumbItemInterface extends React.FC<IBreadcrumbItemProps> {
  __ANT_BREADCRUMB_ITEM: boolean;
}
/**
 * Breadcrumb Item component
 */

const BreadcrumbItem: BreadcrumbItemInterface = (props) => (
  <AntBreadcrumb.Item {...props} />
);

/* eslint no-underscore-dangle: 0 */
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;

export default BreadcrumbItem;
